<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Change Job Site</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <span class="label">Customer</span>
            <select (change)="customerSelected($event.target.value)">
                <option value="" disabled selected>Select Customer</option>
                <option *ngFor="let customer of customers" [value]="customer.customerId">{{customer.customerName}}</option>
                <!--<option value="1">Toms Mining</option>-->
            </select>
        </div>
        <div class="input-container">
            <span class="label">Job Site</span>
            <select (change)="jobsiteSelected($event.target.value)">
                <option value="" disabled selected>Select Job Site</option>
                <option *ngFor="let jobsite of jobsites" [value]="jobsite.jobsiteId">{{jobsite.jobsiteName}}</option>
                <!--<option value="1">Melbourne Mine</option>-->
            </select>
        </div>
        <div class="input-container">
            <span class="label">Cost</span>
            <span class="input-icon">$</span>
            <input type="number" value="0.00" min="0" [(ngModel)]="cost" (ngModelChange)="costChanged()" step="any" />
        </div>
        <div class="input-container">
            <span class="label">Date</span>
            <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()" matTooltip="{{ttDate}}">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker"
                   [min]="minDate" [max]="maxDate" placeholder="Choose a date"
                   [(ngModel)]="eventDate" (ngModelChange)="dateChanged()"
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>
        <div class="margin-bottom-16">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment" (ngModelChange)="commentChanged()" 
                  placeholder="Enter a comment about why the implement was moved to this job site. "
                  matTooltip="{{ttComment}}"></textarea>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>